import {Component} from "@angular/core";
import {FUIStatementComponent} from "../statement.component";

@Component({
    selector: "fui-value-statement",
    styleUrls: ["./value-statement.component.scss"],
    templateUrl: "./value-statement.component.html",
    standalone: false
})
export class FUIValueStatementComponent extends FUIStatementComponent {
}
